 import React from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import {getFeatureGroupName} from "../../../misc/helpers";
import {SQFT_FEATURES, SQFT_PARENT_FEATURE_GROUP_PART_IDS} from "../../sqft/constants";
import COLOR_THEMES from "../../../colorThemes";
 import SqftFeaturesPopupTitleFeatureDropdown from "./sqftFeaturesPopupTitleFeatureDropdown";
 import {getCurrentLayout} from "../../appLayout";
 import sqftConfig from "../../sqft/components/canvas/store/sqftConfig";

const SqftFeaturesPopupParentListTitle = (props) => {
  const { parentKey, parentsList, parentsLists, setParentsLists, rebuildQuoteLists, subPart } = props;
  const { intl, fabricatorData, activeTheme } = props;

  const featureGroupName = getFeatureGroupName(subPart.part, intl, fabricatorData);
  const editButtonColor = COLOR_THEMES[activeTheme].primary;
  const isChangeable = [SQFT_FEATURES.lower_cabinet_boxes, SQFT_FEATURES.upper_cabinet_boxes, SQFT_FEATURES.tall_cabinet_boxes].includes(parentKey)
    && !(sqftConfig.shouldUseCabinetDoorsSQFT || sqftConfig.shouldUseCabinetDoorsLNFT || !sqftConfig.shouldUseCabinetDoorsAndDrawersQuantity);

  let relatedFeatureGroup;
  if (isChangeable) {
    const layout = getCurrentLayout();
    let relatedParentPartId = SQFT_PARENT_FEATURE_GROUP_PART_IDS[parentKey];
    relatedFeatureGroup = layout.getFeatureGroupByPartId(relatedParentPartId);

    // if there is no hardcoded parent feature group then we will take features actual featureGroup
    if (!relatedFeatureGroup) {
      if (
        parentsList &&
        parentsList[parentKey] &&
        Array.isArray(parentsList[parentKey].features) &&
        parentsList[parentKey].features.length > 0 &&
        parentsList[parentKey].features[0] &&
        parentsList[parentKey].features[0].relatedParentFeature &&
        typeof parentsList[parentKey].features[0].relatedParentFeature.getParent === 'function'
      ) {
        relatedFeatureGroup = parentsList[parentKey].features[0].relatedParentFeature.getParent();
      }
    }
  }

  const featureGroup = isChangeable && relatedFeatureGroup ? relatedFeatureGroup : subPart.part;

  return (
    <div className="sqft-popup__title">
      <span className={"selection-footer-list__item-icon sqft-popup__title-icon sqft-popup__title-icon--" + parentKey}/>
      <span className="sqft-popup__title-text">
        {featureGroupName} {isChangeable ? " -" : null}
        {isChangeable ?
          <SqftFeaturesPopupTitleFeatureDropdown editButtonColor = { editButtonColor }
                                                 parentsLists = { parentsLists }
                                                 parentsList = { parentsList }
                                                 setParentsLists = { setParentsLists }
                                                 rebuildQuoteLists = { rebuildQuoteLists }
                                                 visualizerType = { parentsList.quote && parentsList.quote.room ? parentsList.quote.room : document.kvConfig.visualizerType }
                                                 featureGroup = { featureGroup }/>
          : null
        }
      </span>

    </div>
  )
};

SqftFeaturesPopupParentListTitle.propTypes = {
  parentsList: PropTypes.object,
  parentsLists:  PropTypes.array,
  setParentsLists: PropTypes.func.isRequired,
  parentKey: PropTypes.string,
}

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState,
    activeTheme: store.serverState.activeTheme
  };
};
const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopupParentListTitle)
)
